(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('FluxoSituacaoController', FluxoSituacaoController);

    FluxoSituacaoController.$inject = ['SituacaoConfig', 'TransicaoSituacao', 'Cliente', 'AlertService'];

    function FluxoSituacaoController(SituacaoConfig, TransicaoSituacao, Cliente, AlertService) {
        var vm = this;

        vm.clientes = [];
        vm.clienteSelecionado = null;
        vm.situacoes = [];
        vm.transicoes = [];
        vm.novaSituacao = {
            permiteCriarTarefa: true,
            permiteInserirAnalisePo: true,
            inicial: false,
            authorities: ['ROLE_PO', 'ROLE_ATENDENTE']
        };
        vm.novaTransicao = {};
        vm.editando = null;

        vm.carregarClientes = carregarClientes;
        vm.selecionarCliente = selecionarCliente;
        vm.carregarSituacoes = carregarSituacoes;
        vm.carregarTransicoes = carregarTransicoes;
        vm.salvarSituacao = salvarSituacao;
        vm.editarSituacao = editarSituacao;
        vm.cancelarEdicao = cancelarEdicao;
        vm.removerSituacao = removerSituacao;
        vm.adicionarTransicao = adicionarTransicao;
        vm.removerTransicao = removerTransicao;
        vm.clonarPadrao = clonarPadrao;

        vm.opcoesAuthorities = [
            'ROLE_PO',
            'ROLE_ATENDENTE',
            'ROLE_SCRUM',
            'ROLE_DESENVOLVEDOR',
            'ROLE_CLIENTE',
            'ROLE_RESPONSAVEL',
            'ROLE_ADMIN'
        ];

        vm.toggleRole = toggleRole;
        vm.roleMarcado = roleMarcado;
        vm.rolesResumo = rolesResumo;

        carregarClientes();

        function toggleRole(target, authority) {
            if (!target.authorities || !angular.isArray(target.authorities)) {
                target.authorities = [];
            }
            var idx = target.authorities.indexOf(authority);
            if (idx !== -1) {
                target.authorities.splice(idx, 1);
            } else {
                target.authorities.push(authority);
            }
        }

        function roleMarcado(target, authority) {
            var list = target && angular.isArray(target.authorities) ? target.authorities : [];
            return list.indexOf(authority) !== -1;
        }

        function rolesResumo(s) {
            if (!s || !angular.isArray(s.authorities) || s.authorities.length === 0) {
                return '';
            }
            return s.authorities.slice().sort().join(', ');
        }

        function carregarClientes() {
            Cliente.query(function (result) {
                vm.clientes = result;
            });
        }

        function selecionarCliente() {
            carregarSituacoes();
            carregarTransicoes();
        }
        selecionarCliente();

        function getClienteId() {
            return vm.clienteSelecionado ? vm.clienteSelecionado.id : null;
        }

        function carregarSituacoes() {
            SituacaoConfig.query({clienteId: getClienteId()}, function (result) {
                vm.situacoes = result;
            });
        }

        function carregarTransicoes() {
            TransicaoSituacao.query({clienteId: getClienteId()}, function (result) {
                vm.transicoes = result;
            });
        }

        function salvarSituacao() {
            var situacao = vm.editando || vm.novaSituacao;
            if (vm.clienteSelecionado) {
                situacao.cliente = vm.clienteSelecionado;
            }
            if (situacao.id) {
                SituacaoConfig.update(situacao, function () {
                    AlertService.success('Situação atualizada');
                    vm.editando = null;
                    carregarSituacoes();
                });
            } else {
                SituacaoConfig.save(situacao, function () {
                    AlertService.success('Situação criada');
                    vm.novaSituacao = {
                        permiteCriarTarefa: true,
                        permiteInserirAnalisePo: true,
                        inicial: false,
                        authorities: ['ROLE_PO', 'ROLE_ATENDENTE']
                    };
                    carregarSituacoes();
                });
            }
        }

        function editarSituacao(situacao) {
            vm.editando = angular.copy(situacao);
            if (!angular.isArray(vm.editando.authorities)) {
                vm.editando.authorities = [];
            }
        }

        function cancelarEdicao() {
            vm.editando = null;
        }

        function removerSituacao(situacao) {
            if (confirm('Deseja remover a situação "' + situacao.descricao + '"?')) {
                SituacaoConfig.delete({id: situacao.id}, function () {
                    AlertService.success('Situação removida');
                    carregarSituacoes();
                });
            }
        }

        function adicionarTransicao() {
            var transicao = {
                situacaoOrigem: vm.novaTransicao.origem,
                situacaoDestino: vm.novaTransicao.destino,
                ativo: true
            };
            if (vm.clienteSelecionado) {
                transicao.cliente = vm.clienteSelecionado;
            }
            TransicaoSituacao.save(transicao, function () {
                AlertService.success('Transição criada');
                vm.novaTransicao = {};
                carregarTransicoes();
            });
        }

        function removerTransicao(transicao) {
            if (confirm('Deseja remover esta transição?')) {
                TransicaoSituacao.delete({id: transicao.id}, function () {
                    AlertService.success('Transição removida');
                    carregarTransicoes();
                });
            }
        }

        function clonarPadrao() {
            if (!vm.clienteSelecionado) {
                AlertService.warning('Selecione um cliente');
                return;
            }
            SituacaoConfig.clonar({clienteId: vm.clienteSelecionado.id}, function (result) {
                AlertService.success('Fluxo padrão clonado para o cliente');
                vm.situacoes = result;
                carregarTransicoes();
            }, function (error) {
                AlertService.error(error.data.message || 'Erro ao clonar fluxo');
            });
        }
    }
})();
